import { Action } from 'redux';
import { getProductPage, IGetProductPageResponse } from '../api/productsApi';
import { IGetProductPageParams } from '../api/IGetProductPageParams';
import { IPagedDataResponse, IProduct } from '../types';
import { AxiosResponse } from 'axios';

export const GET_PRODUCT_PAGE_REQUEST = 'GET_PRODUCT_PAGE_REQUEST';
export type GET_PRODUCT_PAGE_REQUEST = typeof GET_PRODUCT_PAGE_REQUEST;
export const GET_PRODUCT_PAGE_RESPONSE = 'GET_PRODUCT_PAGE_RESPONSE';
export type GET_PRODUCT_PAGE_RESPONSE = typeof GET_PRODUCT_PAGE_RESPONSE;
export const GET_PRODUCT_PAGE_ERROR = 'GET_PRODUCT_PAGE_ERROR';
export type GET_PRODUCT_PAGE_ERROR = typeof GET_PRODUCT_PAGE_ERROR;

export interface IGetProductPageResponse extends Action {
  type: GET_PRODUCT_PAGE_RESPONSE;
  response: IPagedDataResponse<IProduct>;
}

export interface IGetProductPageError extends Action {
  type: GET_PRODUCT_PAGE_ERROR;
  error?: string;
}

export const getProductPageRequest = (parameters: IGetProductPageParams): any => {
  return (dispatch : any) => {
    dispatch({
      type: GET_PRODUCT_PAGE_REQUEST,
      loadMore: parameters.startIndex > 0,
    });

    return getProductPage(parameters)
      .then((response: AxiosResponse<IGetProductPageResponse>) => {
        if (response.status === 200) {

          dispatch({
            type: GET_PRODUCT_PAGE_RESPONSE,
            response: response.data.products,
            loadMore: parameters.startIndex > 0,
          });

        } else {
          onError(dispatch);
        }
      })
      .catch((err: any) => {
        console.log(err);
        onError(dispatch);
      });
  };
};

const onError = (dispatch: any) => dispatch({
  type: GET_PRODUCT_PAGE_ERROR,
});
